import { CATEGORIES as DEFAULT_CATEGORIES, COMPANY } from './constants';

// ── CATEGORY ICON HELPER ──────────────────────────────────────────────────────
// Pass a dynamic categories array (from context) or fall back to constants
export function getCategoryIcon(categoryId, categories = DEFAULT_CATEGORIES) {
  return categories.find(c => c.id === categoryId)?.icon || '⚙️';
}

export function getCategoryLabel(categoryId, categories = DEFAULT_CATEGORIES) {
  return categories.find(c => c.id === categoryId)?.label || categoryId;
}

// ── IMAGE FILE UTILS ──────────────────────────────────────────────────────────
export function validateImageFile(file) {
  const allowed = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
  if (!allowed.includes(file.type)) return 'Only JPG, PNG, WebP and GIF are allowed.';
  if (file.size > 5 * 1024 * 1024)  return `"${file.name}" exceeds the 5 MB limit.`;
  return null;
}

// ── WHATSAPP URL BUILDERS ─────────────────────────────────────────────────────
export function buildWhatsAppUrl(message) {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${COMPANY.whatsapp}?text=${encoded}`;
}

export function buildMachineEnquiryUrl(machine) {
  const message =
    `Hi Bright Machineries! I'm interested in the following machine:\n\n` +
    `*Machine:* ${machine.title}\n` +
    `*Brand:* ${machine.brand}\n` +
    `*Year:* ${machine.year}\n` +
    `*Location:* ${machine.location}\n\n` +
    `Could you please share more details and availability?`;
  return buildWhatsAppUrl(message);
}

export function buildGeneralEnquiryUrl() {
  const message =
    `Hi Bright Machineries! I'd like to enquire about your machinery stock. ` +
    `Could you please share what's currently available?`;
  return buildWhatsAppUrl(message);
}

// ── UNIQUE ID ─────────────────────────────────────────────────────────────────
export function generateId() {
  return `m-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
}
